import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from 'common/components/Icon';
import Typography from 'common/components/Typography';
import colors from 'common/styles/colors';

import RewardScheduleItem from '../RewardScheduleItem';
import NoRewardsSvg from './NoRewards.svg';
import styles from './index.module.css';

const UnlockScheduleCard = ({ schedule }) => {
  const hasSchedule = schedule && schedule.length > 0;

  return (
    <div className={classNames(styles.root, { [styles.empty]: !hasSchedule })}>
      <div
        className={classNames(styles.content, { [styles.empty]: !hasSchedule })}
      >
        <div className={styles.header}>
          <Icon.TimeDuotone
            className={styles.timeIcon}
            description="Time icon"
            size="medium"
            fill={colors['color-brand-500']}
          />
          <Typography
            tag="h2"
            size="base"
            weight="semiBold"
            color="color-neutral-900"
          >
            Unlock schedule
          </Typography>
        </div>
        <Typography tag="div" size="sm" color="color-neutral-400">
          Upcoming rewards after a 3 month lock period
        </Typography>
        {hasSchedule ? (
          <div className={styles.scheduleList}>
            {schedule.map((item) => (
              <RewardScheduleItem key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <div className={styles.emptyState}>
            <img src={NoRewardsSvg} alt="No rewards" />
            <Typography
              tag="p"
              size="lg"
              weight="semiBold"
              color="color-neutral-900"
              className={styles.emptyTitle}
            >
              No rewards yet
            </Typography>
            <Typography tag="p" size="sm" color="color-neutral-500">
              They&apos;ll be displayed here after your next settlement
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

UnlockScheduleCard.propTypes = {
  schedule: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      amount: PropTypes.string.isRequired,
      period: PropTypes.string.isRequired,
      daysLeft: PropTypes.number.isRequired,
      status: PropTypes.oneOf(['locked', 'unlocked']).isRequired,
      startDate: PropTypes.string.isRequired,
      unlockDate: PropTypes.string.isRequired,
      progress: PropTypes.number.isRequired,
    })
  ),
};

UnlockScheduleCard.defaultProps = {
  schedule: [],
};

export default UnlockScheduleCard;
